/**
 * Created by Ivan on 10.10.2025
 */

const RaveReviewsTutorial = function () {
    return new TutorialScenario("rave_reviews_tutorial", {
        onStart: function () {
            cleverapps.raveReviews.resetReviews();
            RaveReviewsTutorial.highlights = [];
        },

        onFinish: function () {
            delete RaveReviewsTutorial.highlights;
        },

        listSteps: () => [
            RaveReviewsTutorial.RaveReviewsWindowStep(),
            RaveReviewsTutorial.createStartWindowStep(),
            RaveReviewsTutorial.createMinimalStep(),
            RaveReviewsTutorial.createOrderStep(),
            RaveReviewsTutorial.createIconStep({
                text: "RaveReviews.force3",
                disableFallbackTimeout: true
            }),
            RaveReviewsTutorial.waitWindowCloseStep()
        ],

        isAvailable: function () {
            if (!Merge2.current || cleverapps.forces.isShown(Forces.RAVE_RAVIEWS) || !Merge2.current.isGameMode()) {
                return false;
            }

            return cleverapps.raveReviews.onGetView();
        }
    });
};

RaveReviewsTutorial.getOrdersScroll = function () {
    return cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTableViewControl;
};

RaveReviewsTutorial.RaveReviewsWindowStep = function () {
    const options = {
        onStart: function () {
            new RaveReviewsWindow();
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
            cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.focusManager.setEventNodes([]);
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

RaveReviewsTutorial.createStartWindowStep = function () {
    const options = {
        onStart: function () {
            RaveReviewsTutorial.getOrdersScroll()._setGlobalZOrder(true);

            cleverapps.raveReviews.startNextStage(this.finish.bind(this));
            cleverapps.tutorial.on("showReviewsAnimation", (reviewsBg) => {
                RaveReviewsTutorial.highlights.push(reviewsBg);
                reviewsBg._setGlobalZOrder(true);
            }, this);
        },

        onFinish: function () {
            RaveReviewsTutorial.highlights.forEach((reviewsBg) => {
                reviewsBg._setGlobalZOrder(false);
            });

            RaveReviewsTutorial.getOrdersScroll()._setGlobalZOrder(false);
            RaveReviewsTutorial.highlights.push(RaveReviewsTutorial.getOrdersScroll());

            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

RaveReviewsTutorial.createMinimalStep = function () {
    const options = {
        onStart: function () {
            cleverapps.forces.create(ForceView.NO_ELEMENT, Forces.RAVE_RAVIEWS, {
                highlights: RaveReviewsTutorial.highlights.concat([cleverapps.raveReviews.onGetView()])
            });
            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

RaveReviewsTutorial.createOrderStep = function () {
    const options = {
        onStart: function () {
            const ordersTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable;
            const customers = ordersTable.rows.filter((row) => row.data instanceof Merge2Customer && !row.data.recipe.sideQuest && !row.data.eventOrder).map((row) => row.data.onGetView());

            if (!customers.length) {
                this.finish();
                return;
            }

            cleverapps.forces.create(ForceView.NO_ELEMENT, {
                text: "RaveReviews.force2",
                disableFallbackTimeout: true,
                position: () => MinimalDialogue.POSITIONS.CENTER,
                okButton: true
            }, {
                highlights: RaveReviewsTutorial.highlights.concat([customers[0]])
            });

            cleverapps.tutorial.on("touchInShadow", this.finish.bind(this), this);
        },

        onFinish: function () {
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};

RaveReviewsTutorial.createIconStep = function (force) {
    return new TutorialStep({
        onStart: function () {
            const ordersTable = cleverapps.Scenes.GetSceneComponent(Merge2SceneComponent).ordersTable;

            const createForce = () => {
                Merge2TutorialHelper.scrollToExtraBarRow(cleverapps.raveReviews.index, () => {
                    this.force && this.force.close();

                    const view = cleverapps.raveReviews.onGetView();
                    const tapTarget = ComponentUtils.findChildrenByTag(view, "tapTarget")[0];
                    const fingerForce = tapTarget && cleverapps.raveReviews.isCompleted() ? { ...force, finger: { tap: tapTarget } } : force;

                    this.force = cleverapps.forces.create(view, fingerForce);
                });
            };

            const onResize = cleverapps.accumulate(0, () => {
                const isVertical = cleverapps.resolution.mode === cleverapps.WideMode.VERTICAL;

                if (this.forceTimeout) {
                    cleverapps.timeouts.clearTimeout(this.forceTimeout);
                    delete this.forceTimeout;
                }

                if (this.force) {
                    this.force.hideForceHints();
                }

                if (!isVertical) {
                    ordersTable.scrollToRow("rave_review");
                    this.forceTimeout = cleverapps.timeouts.setTimeout(createForce, 600);
                } else {
                    createForce();
                }
            });

            onResize();

            cleverapps.tutorial.on("onResize", onResize, this);
            cleverapps.tutorial.on("window_shown", this.finish.bind(this), this);
        },

        onFinish: function () {
            if (this.forceTimeout) {
                cleverapps.timeouts.clearTimeout(this.forceTimeout);
                delete this.forceTimeout;
            }
            this.force.hideForceHints();
            Merge2.current.counter.trigger();
        }
    });
};

RaveReviewsTutorial.waitWindowCloseStep = function () {
    const options = {
        onStart: function () {
            cleverapps.focusManager.setEventNodes([cleverapps.focusManager.currentWindow()]);
            cleverapps.tutorial.on("window_closed", this.finish.bind(this), this);
        },

        onFinish: function () {
            cleverapps.focusManager.setEventNodes([cleverapps.Scenes.GetRunningScene()]);
            Merge2.current.counter.trigger();
        }
    };

    return new TutorialStep(options);
};
